import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M13.26 4.75a1.886 1.886 0 0 0-1.877 0L6.436 7.606c-.58.342-.936.964-.936 1.627v5.7c0 .676.358 1.294.933 1.626l4.947 2.857h.002a1.886 1.886 0 0 0 1.876.001l4.948-2.857c.58-.342.936-.963.936-1.627v-5.7c0-.67-.355-1.284-.936-1.627L13.26 4.751h-.001Zm-2.627-1.3a3.386 3.386 0 0 1 3.373-.001l.002.002 4.95 2.858.005.003a3.385 3.385 0 0 1 1.679 2.921v5.7a3.395 3.395 0 0 1-1.679 2.922l-.005.003-4.95 2.858a3.386 3.386 0 0 1-3.372.002l-.003-.002-4.95-2.858A3.375 3.375 0 0 1 4 14.933v-5.7c0-1.202.643-2.313 1.678-2.921l.005-.003 4.95-2.858Zm1.692 4.343a.75.75 0 0 1 .75.75v4.375a.75.75 0 1 1-1.5 0V8.543a.75.75 0 0 1 .75-.75Zm1 7.792a1 1 0 1 0-2 0v.083a1 1 0 0 0 2 0v-.083Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReport;
